import React, { useState } from 'react';
import Accordion from '../../components/common/Accordian';
import EditIcon from '../../assets/EditIcon';
import EditIconDark from '../../assets/EditIconDark';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import Table from '../common/Table/Table';
import ReusableButton from '../common/Button/Button';
import CrossIcon from '../../assets/CrossIcon';
import CheckIcon from '../../assets/CheckIcon';
import { IUpComingStaffCompliance } from '../../type/upComingStaffCompliance';
import useBgColorStore from '../../store/bgColor';
import CrossIconDarkForm from '../../assets/icon/CrossIconForm';

type Props = {
  title: string;
  headers: { label: string }[];
  rows: React.ReactNode[][];
  allocatedStaff?: { [key: number]: number };
  updatedAllocations: { [key: number]: number };
  isEditMode?: boolean;
  isEdit?: boolean;
  onEditClick?: () => void;
  onCancel: () => void;
  onSave: () => void;
  userCanEditStaffCompliance?: Boolean;
  driverAccordionIsOpen?: boolean;
  toggleState?: (isOpen: boolean) => void;
  editPermissionForBalloonCompliance?:boolean
};

const ComplianceSection: React.FC<Props> = ({
  title,
  headers,
  rows,
  allocatedStaff,
  updatedAllocations,
  isEditMode,
  isEdit,
  onEditClick,
  onCancel,
  onSave,
  userCanEditStaffCompliance,
  driverAccordionIsOpen,
  toggleState,
}) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  return (
    <Accordion
      title={title}
      icon={
        userCanEditStaffCompliance ? (
          <button onClick={onEditClick}>
            <div>
              <div className="block dark:hidden">
                <EditIcon />
              </div>
              <div className="hidden dark:block">
                <EditIconDark />
              </div>
            </div>
            {/* <EditIcon /> */}
          </button>
        ) : undefined
      }
      bgColor={`${bgColor}`}
      accordionIsOpen={driverAccordionIsOpen}
      toggleState={toggleState}
      iconOpen={
        <div>
          <div className="block dark:hidden">
            <AccordianDownIcon />
          </div>
          <div className="hidden dark:block">
            <AccordianDownIconDark />
          </div>
        </div>
      }
      iconClose={
        <div>
          <div className="block dark:hidden">
            <AccordianUpIcon />
          </div>
          <div className="hidden dark:block">
            <AccordianUpIconDark />
          </div>
        </div>
      }
    >
      <div className="p-4">
        <Table
          headers={headers}
          rows={rows}
          isPageLoading={false}
          allocatedStaff={
            isEditMode
              ? updatedAllocations
              : allocatedStaff && Object.keys(allocatedStaff).length > 0
                ? allocatedStaff
                : undefined
          }
          isEditMode={isEditMode}
          tableBg="bg-background"
          isEdit={isEdit}
        />
        {isEditMode && (
          <div className="flex w-full justify-end gap-2 mt-4 ">
            <ReusableButton
              variant="secondary"
              children={'Cancel'}
              icon={
                <div>
                  <div className="block dark:hidden">
                    <CrossIcon />
                  </div>
                  <div className="hidden dark:block">
                    <CrossIconDarkForm />
                  </div>
                </div>
              }
              className="w-auto bg-button-cancelButtonBgColor text-text-cancelButtonTextColor"
              onClick={onCancel}
            />
            <ReusableButton
              icon={<CheckIcon />}
              children={'Confirm'}
              variant="primary"
              className="w-auto bg-background-backgroundColor"
              onClick={onSave}
            />
          </div>
        )}
      </div>
    </Accordion>
  );
};

export default ComplianceSection;
